import Text from '@tiptap/extension-text';
import { MarkdownNodeSpec } from 'tiptap-markdown';

function escapeHTML(text: string): string {
  return text?.replace(/</g, '<').replace(/>/g, '>');
}

export default Text.extend({
  addStorage(): { markdown: MarkdownNodeSpec } {
    return {
      markdown: {
        serialize(state, node) {
          state.text(escapeHTML(node.text ?? ''));
        },
        parse: {
          // handled by markdown-it
        },
      },
    };
  },
});
